import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Deduplicates an array based on a unique identifier property.
 * Uses the first occurrence of each unique ID.
 */
export function deduplicateById<T extends { id: string }>(items: T[]): T[] {
  return items.filter((item, index, arr) => arr.findIndex((i) => i.id === item.id) === index);
}

/**
 * Converts an array of objects with id and name properties to select options.
 */
export function toSelectOptions<T extends { id: string; name: string }>(
  items: T[],
): Array<{ value: string; label: string }> {
  return items.map((item) => ({ value: item.id, label: item.name }));
}

/**
 * Filters an array of objects by an array of IDs.
 */
export function filterByIds<T extends { id: string }>(items: T[], ids: string[]): T[] {
  return items.filter((item) => ids.includes(item.id));
}

/**
 * Generates a timestamp string suitable for filenames.
 * Format: ISO string with colons and periods replaced by dashes.
 */
export function getFileTimestamp(): string {
  return new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5);
}

/**
 * Returns the current ISO timestamp.
 */
export function nowIso(): string {
  return new Date().toISOString();
}
